module.exports = __webpack_public_path__ + "img/map-loc-img3.9929631b.png";